import { registerEnumType } from 'type-graphql'

export enum ReturnItemResolutionEnum {
  Refund = 'Refund',
  ReturnlessRefund = 'ReturnlessRefund',
  Replace = 'Replace',
}

registerEnumType(ReturnItemResolutionEnum, {
  name: 'ReturnItemResolutionEnum',
  description: 'Per-line resolution for a returned item.',
})
